import { Button, CardContent, Typography, Grid, Drawer, Avatar, Tooltip, Modal, IconButton } from '@mui/material';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';

import CustomDataGrid from '../DataGrid/DataGrid';
import { useAppDispatch, useAppSelector, } from "../../store/hooks";
import { ApiStatus } from "../../utils/api.types";
import { Box } from '@mui/system';
import { GridActionsCellItem, GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
// import { PermissionsEnum } from "../../utils/auth.types";
import { StyledCard } from '../AccountBasicInfo/AccountBacisInfo.styles';
import DialogDocAttachForm from './DialogDocAttachForm';
import { deleteDoc, updateDocStatus } from '../../store/docAttachThunk';
import { IUserDocAttach } from '../../utils/docAttach.types';
import { styled } from '@mui/material/styles';
import { Height } from '@mui/icons-material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import SwipeIcon from '@mui/icons-material/Swipe';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import LoadingButton from '@mui/lab/LoadingButton';

// const style = {
//   position: 'absolute' as 'absolute',
//   top: '50%',
//   left: '50%',
//   transform: 'translate(-50%, -50%)',
//   transition: '0ms',
//   width: 425,
//   borderRadius: 2,
//   bgcolor: 'background.paper',
//   border: 'none',
//   boxShadow: 24,
//   height: 'fit-content'
// };


export interface IDoc {
  _id?: string;
  url?: string;
  key?: string;
  filename?: string;
  size?: string;
  createdAt?: string;
  updatedAt?: string;
};

interface DocumentAttachProps {
  docAttachId?: string;
  docList?: IDoc[];
  onDelete?: (data: any) => void
  onClose?: (k: any) => void;
  collectionName?: string;
  collectionRefId?: string;
}

const DocAttachInfo: FC<DocumentAttachProps> = (props) => {
  const { permissions } = useAppSelector(state => state.auth);
  const [docsList, setDocsList] = useState<Array<IDoc>>([]);
  const [open, setOpen] = useState(false);
  const [docAttachId, setDocAttachId] = useState('');
  const [fetchData, setFetchData] = useState('');
  const { status } = useAppSelector(state => state.docAttach);
  const dispatch = useAppDispatch();
  // const canDeleteAccount = permissions?.includes(PermissionsEnum.Account_Delete);
  const [attchmentModel, setAttachmentModel] = useState(false);

  useEffect(() => {
    if (props.docList) {
      setDocsList(props.docList);
    }

  }, [props.docList])

  const openDocAttachForm = (docId: string) => {
    setDocAttachId(docId);
    setOpen(true);
  }

  const closeDialog = (isSaved: boolean) => {
    setOpen(false);
    setAttachmentModel(false)

    if (isSaved) {
      if (props.onClose) {
        props.onClose(true);
      }
      setFetchData(Math.random().toString());
    }
  }

  // Method to handle delete item.
  const deleteSelectedDoc = (item: IUserDocAttach) => () => {
    // Dispatch action to delete.
    dispatch(deleteDoc({id: item._id, collectionName: props.collectionName, collectionRefId: props.collectionRefId}));
    if (props.onDelete) {
      props.onDelete(item._id);
    }
  };

  const handleChangeDocStatus = (docId: string, status: string) => {
    let data = {
      id: docId,
      status: status
    }
    dispatch(updateDocStatus(data))
    closeDialog(true);
    setFetchData(Math.random().toString());
  };

  // Column defs for documents list data grid.
  const columns: GridColDef[] = useMemo(() => [
    {
      field: "preview",
      headerName: 'Preview',
      type: "string",
      flex: 0.8,

      renderCell: (params: GridValueGetterParams) => {

        return <>
          
          <Tooltip title="Download">
            <a href={params.row.url} target="_blank" style={{color: '#48a563'}}>
            {/* <CloudDownloadIcon/> */}
              {
                params.row.mimeType == "application/pdf" ?
                  <><PictureAsPdfIcon/> Donwload PDF</>
                :
                  <img style={{ 'maxWidth': '45px', 'maxHeight': '45px' }} src={params.row.url} />
                
              }
              
            </a>
          </Tooltip>
        </>;
      }
    },
    {
      field: "attachmentLabel",
      headerName: 'Doc Label',
      type: "string",
      flex: 1,
      renderCell: (params: GridValueGetterParams) => {

        return <> { params.row.attachmentLabel || '' } </>;
      }
    },
    {
      field: "name",
      headerName: 'File',
      type: "string",
      flex: 1,

      renderCell: (params: GridValueGetterParams) => {

        return <>
          {params.row.originalname}
        </>;
      }
    },
    {
      field: "collectionName",
      headerName: 'Reference',
      type: "string",
      flex: 1,
      renderCell: (params: GridValueGetterParams) => {

        return <> { params.row.collectionName || '' } </>;
      }
    },
    {
      field: "size",
      headerName: 'Size',
      type: "string",
      flex: 0.7,

      renderCell: (params: GridValueGetterParams) => {

        return <>
          {formatBytes(params.row.sizeInBytes || 0, 0)}
        </>;
      }
    },
    {
      field: "status",
      headerName: 'Status',
      type: "string",
      flex: 1.2,
      renderCell: (params: GridValueGetterParams) => {

        return <>
          <Tooltip title={params.row.status}>
            <>
              { params.row.status == "PENDING" && 
                <>
                  <Tooltip title="PENDING"><PendingActionsIcon color='warning'/></Tooltip>
                  <LoadingButton
                    className='buttonContainedRoot'
                    size='small'
                    type="button"
                    name='approve'
                    style={{ color:'#488dff',backgroundColor:'#fff',border:'0.5px solid #488dff',height:30,borderRadius:7, marginLeft: '10px'}}
                    variant="contained"
                    onClick={(e) => handleChangeDocStatus(params.row._id, "APPROVED")}
                  > 
                    Mark Approve
                  </LoadingButton> 
                </>
              }
              { params.row.status == "APPROVED" &&
                <>
                  <Tooltip title="APPROVED"><CheckCircleIcon color='success'/></Tooltip>
                  <LoadingButton
                    className='buttonContainedRoot'
                    size='small'
                    type="button"
                    name='approve'
                    style={{ color:'#488dff',backgroundColor:'#fff',border:'0.5px solid #488dff',height:30,borderRadius:7, marginLeft: '10px'}}
                    variant="contained"
                    onClick={(e) => handleChangeDocStatus(params.row._id, "REJECTED")}
                  > 
                    Mark Reject
                  </LoadingButton> 
                </>
              }
              { params.row.status == "REJECTED" && <><Tooltip title="REJECTED"><CancelIcon color='error'/></Tooltip> <label color='error'> Rejected </label> </>}
            </>
          </Tooltip>
        </>;
      }
    },
    {
      field: "actions",
      headerName: 'Actions',
      type: "actions",
      flex: 0.7,
      getActions: (params: GridValueGetterParams) => {

        const deleteAction = (
          <GridActionsCellItem
            icon={<><Tooltip title="Delete Document"><DeleteIcon color='error'/></Tooltip></>}
            title="Delete"
            label="Delete"
            onClick={deleteSelectedDoc(params.row)}
          />
        );

        const actions: JSX.Element[] = [];

        // Push edit action if user has delete permission.
        // if (canDeleteAccount) {
        actions.push(deleteAction);
        // }

        return actions;
      }
    }
  ], []);

  //Fetch current selected account .
  useEffect(() => {
    if (fetchData) {

    }
  }, [fetchData]);

  const onClose2 = () => {
    setAttachmentModel(false)
}

  return (
    <>
    <StyledCard style={{height: 0}}>
      <CardContent>
        <Typography className={'cardHeader'} variant="h4" component="div">
          <Box>Documents</Box>
          <Button onClick={() => { openDocAttachForm('') }} variant='outlined'>Attach Documents</Button>
          {/* <Button onClick={() => setAttachmentModel(true)} variant='outlined'>Attach Documents</Button> */}

          <Drawer
            anchor="right"
            open={open}
          >
            {<DialogDocAttachForm open={open} onClose={closeDialog} docAttachId={docAttachId} collectionName={props.collectionName} collectionRefId={props.collectionRefId}></DialogDocAttachForm>}
          </Drawer>
        </Typography>

        <div style={{ height: 350, width: '100%', padding: '10px'}}>
          {docsList && <CustomDataGrid
            columns={columns}
            rows={docsList}
            getRowId={(row) => row._id}
            loading={status === ApiStatus.LOADING} />}
        </div>

        {/* <Modal
          open={attchmentModel}
          onClose={(event : any, reason:any) => {
              if (reason !== 'backdropClick') {
                setAttachmentModel(true)
              }
          }} >
            <>
            <Box sx={style}>
              <Grid container>
                  <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p:2, pl:2, bgcolor:'#e9ecf1' }} style={{borderTopLeftRadius:8,borderTopRightRadius:8,height:50}} >
                    <div style={{float:'right',marginTop:-7,marginRight:-5}}>
                        <IconButton size='small' onClick={onClose2} style={{marginRight:-5}} >
                            <HighlightOffOutlinedIcon  color="error"/>
                        </IconButton>
                    </div>
                    <h3  style={{marginTop:-2}}>Attach Document</h3>
                  </Grid>
                  
              </Grid>
              <DialogDocAttachForm open={open} onClose3={closeDialogAttach} docAttachId={docAttachId}></DialogDocAttachForm>
            </Box>
            
          
          </>

        </Modal> */}

      </CardContent>
    </StyledCard>
    </>
  );
};

export default DocAttachInfo;


function formatBytes(bytes: number, decimals = 2) {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}